import React from 'react';
import MainInfoTracLayout from '../../../components/Layout/Main';
import Content from '../../../components/Pages/JobStatus/Details';
import JobDetailsProvider from '../../../context/jobDetails';
import GlobalSearchProvider from '../../../context/globalSearch';

function JobDetails() {
  return (
    <MainInfoTracLayout>
      <JobDetailsProvider>
        <GlobalSearchProvider>
          <Content />
        </GlobalSearchProvider>
      </JobDetailsProvider>
    </MainInfoTracLayout>
  );
}

export default JobDetails;
